import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAsyncDispatch } from "shared/helpers/hooks/useAsyncDispatch";
import { requiredRules } from "shared/helpers/validators";
import BasicAutocomplete from "shared/ui/Autocomplete";
import {
  GetTranslationLanguages,
  selectTranslationLanguages,
} from "store/slicers/campaignTranslations";

const languagesList = ["hy", "en", "ru"];

const AddCampaignTranslationLanguage = ({ name = "language" }) => {
  const [options, setOptions] = useState([]);
  const [hasSeeMoreOption, setHasSeeMoreOption] = useState(true);
  const dispatch = useAsyncDispatch();
  const languages = useSelector(selectTranslationLanguages);

  const getMoreOptions = async () => {
    setOptions(languages);
    setHasSeeMoreOption(false);
  };

  const initialFetch = useCallback(async () => {
    const { payload } = await dispatch(GetTranslationLanguages());
    if (payload.length) {
      const filtered = payload.filter((lang) =>
        languagesList.includes(lang.code)
      );
      setOptions(filtered);
    }
  }, [dispatch]);

  useEffect(() => {
    initialFetch();
  }, [initialFetch]);

  return (
    <BasicAutocomplete
      options={options}
      inputLabel={"language"}
      optionLabel="name"
      defaultValue={null}
      name={name}
      rules={requiredRules}
      getMoreOptions={getMoreOptions}
      hasSeeMoreOption={hasSeeMoreOption}
    />
  );
};

export default AddCampaignTranslationLanguage;
